import { useEffect } from 'react';

/**
 * Per-page browser-tab titles: "Angelita Jackson · Shale", "Cases · Shale".
 * A paralegal with eight cases open can tell the tabs apart.
 */
export function useDocumentTitle(...parts: Array<string | null | undefined>) {
  useEffect(() => {
    const title = [...parts.filter(Boolean), 'Shale'].join(' · ');
    document.title = title;
    return () => {
      document.title = 'Shale';
    };
  }, [parts.filter(Boolean).join('·')]); // eslint-disable-line react-hooks/exhaustive-deps
}
